import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';

import ReadMore from '@components/shared/ReadMore/ReadMore';
import { useTheme } from '@components/theme';
import classnames from 'classnames';
import styles from './BoardDescription.module.scss';

BoardDescription.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
};

BoardDescription.defaultProps = {
  className: '',
  description: '',
};

export default function BoardDescription(props) {
  const { className, description } = props;

  const theme = useTheme();

  const [expanded, setExpanded] = useState(false);

  if (!description) {
    return null;
  }

  return (
    <>
      <div className={classnames(
        theme.styles.Body,
        styles.MobileDescriptionContainer,
        className,
      )}
      >
        <button
          className={ styles.MobileDescriptionButton }
          onClick={ () => setExpanded(!expanded) }
          type="button"
        >
          Description

          <span className={`havenly-icon caret ${styles.MobileCaret} ${expanded && styles.MobileCaretExpanded}`} />
        </button>
        <h2
          className={ `
            ${styles.MobileDescription}
            ${expanded ? styles.isExpanded : ''}
          ` }
        >
          {description}
        </h2>
      </div>
      {description.length > 20 && (
        <ReadMore
          className={ `${styles.DesktopDescriptionContainer} ${theme.styles.Body} ${className}` }
          expanded={ expanded }
          setExpanded={ setExpanded }
        >
          <h2>{description}</h2>
        </ReadMore>
      )}
    </>
  );
}
